import { render, staticRenderFns } from "./TrangCauHinhChucNangOtp.vue?vue&type=template&id=763bb747&scoped=true&"
import script from "./TrangCauHinhChucNangOtp.vue?vue&type=script&lang=js&"
export * from "./TrangCauHinhChucNangOtp.vue?vue&type=script&lang=js&"
import style0 from "./TrangCauHinhChucNangOtp.vue?vue&type=style&index=0&id=763bb747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763bb747",
  null
  
)

export default component.exports